import {
  createRouter,
  createWebHashHistory,
  RouteRecordRaw,
} from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    // ホーム画面
    path: "/home",
    name: "HomePage",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "@/views/home/HomePage.vue"
      )
  },
  {
    // ホームサービス一覧画面
    path: "/home-service",
    name: "ServiceListPage",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "@/views/home/ServiceListPage.vue"
      )
  },
  {
    // おすすめ、人気詳細画面
    path: "/home-recommend",
    name: "HomeRecommendPage",
    component: () =>
      import(
        /* webpackChunkName: "home" */ "@/views/home/HomeRecommendPage.vue"
      )
  },
  {
    // レシピ詳細画面
    path: "/recipe-detail",
    name: "RecipeDetailPage",
    component: () =>
      import(
        /* webpackChunkName: "recipe" */ "@/views/recipes/RecipeDetailPage.vue"
      )
  },
  {
    // レシピ検索画面
    path: "/recipe-search",
    name: "RecipeSearchPage",
    component: () =>
      import(
        /* webpackChunkName: "search" */ "@/views/search/RecipeSearchPage.vue"
      )
  },
  {
    // 検索詳細画面
    path: "/search-detail",
    name: "SearcDetailhPage",
    component: () =>
      import(
        /* webpackChunkName: "search" */ "@/views/search/SearchDetailPage.vue"
      )
  },
  {
    // 検索結果画面
    path: "/search",
    name: "SearchPage",
    component: () =>
      import(
        /* webpackChunkName: "search" */ "@/views/search/SearchPage.vue"
      )
  },
  {
    // 人気詳細画面
    path: "/search-recommend",
    name: "SearchRecommendPage",
    component: () =>
      import(
        /* webpackChunkName: "search" */ "@/views/search/SearchRecommendPage.vue"
      )
  },
  {
    // お気に入りタブ
    path: "/favorites",
    name: "FavoritesPage",
    component: () =>
      import(
        /* webpackChunkName: "favorites" */ "@/views/favorites/FavoritesPage.vue"
      )
  },
  {
    // お気に入り 履歴一覧
    path: "/historylist",
    name: "HistoryRecipeListPage",
    component: () =>
      import(
        /* webpackChunkName: "favorites" */ "@/views/favorites/HistoryRecipeListPage.vue"
      )
  },
  {
    // マイリスト フォルダ詳細（レシピ一覧）
    path: "/mylist-folder",
    name: "MyListFolderPage",
    component: () =>
      import(
        /* webpackChunkName: "favorites" */ "@/views/favorites/MyListFolderPage.vue"
      )
  },
  {
    // マイリスト 追加レシピ洗濯
    path: "/mylist-select",
    name: "MyListSelectPage",
    component: () =>
      import(
        /* webpackChunkName: "favorites" */ "@/views/favorites/MyListSelectPage.vue"
      )
  },
  {
    // 買い物リスト
    path: "/shoppingList",
    name: "ShoppingListPage",
    component: () =>
      import(
        /* webpackChunkName: "shoppingList" */ "@/views/shoppingList/ShoppingListPage.vue"
      )
  },
  {
    // 買い物リスト
    path: "/shoppingListAppendIngredient",
    name: "ShoppingListAppendIngredientPage",
    component: () =>
      import(
        /* webpackChunkName: "shoppingList" */ "@/views/shoppingList/ShoppingListAppendIngredientPage.vue"
      )
  },
  {
    // 買い物リスト
    path: "/shoppingListSearchResult",
    name: "shoppingListSearchResultPage",
    component: () =>
      import(
        /* webpackChunkName: "shoppingList" */ "@/views/shoppingList/ShoppingListSearchResultPage.vue"
      )
  },
  {
    // 冷蔵庫エコナビ運転率
    path: "/fridgeEconavi",
    name: "FridgeEconaviPage",
    component: () =>
      import(
        /* webpackChunkName: "fridgeDetails" */ "@/views/fridgeDetails/FridgeEconaviPage.vue"
      )
  },
  {
    // 冷蔵庫ドアモニター
    path: "/fridgeDoorMonitor",
    name: "FridgeDoorMonitorPage",
    component: () =>
      import(
        /* webpackChunkName: "fridgeDetails" */ "@/views/fridgeDetails/FridgeDoorMonitorPage.vue"
      )
  },
  {
    // 冷蔵庫 電気代削減
    path: "/fridgeReductionInfo",
    name: "FridgeReductionInfoPage",
    component: () =>
      import(
        /* webpackChunkName: "fridgeDetails" */ "@/views/fridgeDetails/FridgeReductionInfoPage.vue"
      )
  },
  {
    // 冷蔵庫 本体設定
    path: "/fridgeSettings",
    name: "FridgeSettingsPage",
    component: () =>
      import(
        /* webpackChunkName: "fridgeDetails" */ "@/views/fridgeDetails/FridgeSettingsPage.vue"
      )
  },
  {
    // 冷蔵庫 本体設定ー時間設定
    path: "/fridgeSettingsTime",
    name: "FridgeSettingsTimePage",
    component: () =>
      import(
        /* webpackChunkName: "fridgeDetails" */ "@/views/fridgeDetails/FridgeSettingsTimePage.vue"
      )
  },
  {
    // 冷蔵庫 通知設定
    path: "/fridgePushSettings",
    name: "FridgePushSettingsPage",
    component: () =>
      import(
        /* webpackChunkName: "fridgeDetails" */ "@/views/fridgeDetails/FridgePushSettingsPage.vue"
      )
  },
  {
    // 冷蔵庫 クーリングアシスト
    path: "/fridgeCoolingAssist",
    name: "FridgeCoolingAssistPage",
    component: () =>
      import(
        /* webpackChunkName: "fridgeDetails" */ "@/views/fridgeDetails/FridgeCoolingAssistPage.vue"
      )
  },
  {
    // 冷蔵庫 クーリングアシスト
    path: "/fridgeCoolingAssistSettings",
    name: "FridgeCoolingAssistSettingsPage",
    component: () =>
      import(
        /* webpackChunkName: "fridgeDetails" */ "@/views/fridgeDetails/FridgeCoolingAssistSettingsPage.vue"
      )
  },
  {
    // 冷蔵庫 クーリングアシスト
    path: "/fridgeMyAssistEditing",
    name: "FridgeMyAssistEditingPage",
    component: () =>
      import(
        /* webpackChunkName: "fridgeDetails" */ "@/views/fridgeDetails/FridgeMyAssistEditingPage.vue"
      )
  },
  {
    // 冷蔵庫 クーリングアシスト編集
    path: "/fridgeMyAssistListEdit",
    name: "FridgeMyAssistListEditPage",
    component: () =>
      import(
        /* webpackChunkName: "fridgeDetails" */ "@/views/fridgeDetails/FridgeMyAssistListEditPage.vue"
      )
  },
  {
    // パントリー画面
    path: "/pantry",
    name: "PantryPage",
    component: () =>
      import(
        /* webpackChunkName: "pantry" */ "@/views/pantry/PantryPage.vue"
      )
  },
  {
    // カメラ画像画面
    path: "/pantry-camera",
    name: "PantryCameraPage",
    component: () =>
      import(
        /* webpackChunkName: "pantryCamera" */ "@/views/pantry/PantryCameraPage.vue"
      )
  },
  {
    // 食材詳細画面
    path: "/pantry-detail",
    name: "PantryDetailPage",
    component: () =>
      import(
        /* webpackChunkName: "pantryDetail" */ "@/views/pantry/PantryDetailPage.vue"
      )
  },
  {
    // PR食材画面
    path: "/pantry-pr-food",
    name: "PantryPRFoodPage",
    component: () =>
      import(
        /* webpackChunkName: "pantryPRFood" */ "@/views/pantry/PantryPRFoodPage.vue"
      )
  },
  {
    // 画像拡大
    path: "/pantry-camera-zoom",
    name: "PantryImageZoomPage",
    component: () =>
      import(
        /* webpackChunkName: "pantryZoom" */ "@/views/pantry/PantryImageZoomPage.vue"
      )
  },
  {
    // 使用済みチェック画面
    path: "/pantry-used-up-check",
    name: "PantryUsedUpCheckPage",
    component: () =>
      import(
        /* webpackChunkName: "pantryUsedUpCheck" */ "@/views/pantry/PantryUsedUpCheckPage.vue"
      )
  },
  {
    // 食材追加画面
    path: "/pantry-add",
    name: "PantryAddPage",
    component: () =>
      import(
        /* webpackChunkName: "pantryAdd" */ "@/views/pantry/PantryAddPage.vue"
      )
  },
  {
    // 光軸設定画面
    path: "/pantry-option-axis",
    name: "PantryOptionAxisPage",
    component: () =>
      import(
        /* webpackChunkName: "pantryOptionAxis" */ "@/views/pantry/PantryOptionAxisPage.vue"
      )
  },
  {
    // マイページ
    path: "/mypage",
    name: "MypagePage",
    component: () =>
      import(
        /* webpackChunkName: "mypage" */ "@/views/mypage/MypagePage.vue"
      )
  },
  {
    // マイページ お気に入り／フォルダのレシピ
    path: "/mypage-folder",
    name: "MypageFolderPage",
    component: () =>
      import(
        /* webpackChunkName: "mypage" */ "@/views/mypage/MypageFolderPage.vue"
      )
  },
  {
    // マイページ お気に入り食材
    path: "/mypage-foods",
    name: "MypageFavoriteFoodsPage",
    component: () =>
      import(
        /* webpackChunkName: "mypage" */ "@/views/mypage/MypageFavoriteFoodsPage.vue"
      )
  },
  {
    // マイページ 閲覧履歴
    path: "/mypage-history",
    name: "MypageHistoryRecipePage",
    component: () =>
      import(
        /* webpackChunkName: "mypage" */ "@/views/mypage/MypageHistoryRecipePage.vue"
      )
  },
  {
    // マイページ レポート
    path: "/mypage-report",
    name: "MypageMonthlyFoodsRankingPage",
    component: () =>
      import(
        /* webpackChunkName: "mypage" */ "@/views/mypage/MypageMonthlyFoodsRankingPage.vue"
      )
  },
  {
    // マイページ レポート
    path: "/mypage-report-detail",
    name: "MypageMonthlyFoodsRankingDetailPage",
    component: () =>
      import(
        /* webpackChunkName: "mypage" */ "@/views/mypage/MypageMonthlyFoodsRankingDetailPage.vue"
      )
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
